import React, { FC } from "react";
import { Dialog, DialogContent, DialogActions, Button, DialogTitle, Typography } from "@material-ui/core";
import './style.scss'
import { Trans } from "@lingui/macro";
import CloseIcon from '@material-ui/icons/Close';

interface ModalProps {
    open: boolean,
    onClose: any,
    onAgree?: any,
    onDisagree?: any,
    onFile?: any,
    title?: string,
    agreeText?: any,
    disagreeText?: string,
    disagreeButton?: string,
    agreeButton?: any,
    icon?: any,
    transition?: any,
    children?: any,
    loader?: boolean,
    style?: 1 | 2 | 3,
    closeButton?: boolean
}

const Modal: FC<ModalProps> = ({
    open, onClose, onAgree, onDisagree, title, agreeText,
    disagreeText, icon, loader, onFile,
    transition, children, closeButton = false, style = 1, ...rest
}) => {
    return (
        <Dialog
            className={`custom-modal-${style}`}
            {...rest}
            open={open}
            TransitionComponent={transition}
            onClose={onClose}
            fullWidth
        >
            {closeButton && <CloseIcon className='close-button' onClick={onClose} />}
            {/* @ts-ignore */}
            {title && <DialogTitle id="alert-dialog-slide-title"><Trans>{title}</Trans></DialogTitle>}
            <DialogContent>
                <DialogContent id="alert-dialog-slide-description">
                    {children}
                </DialogContent>
            </DialogContent>
            <DialogActions className={'test rtl'}>

                {(onAgree && agreeText) && <Button className={'agree-button'} onClick={onAgree} color="primary" disabled={loader}>
                    {agreeText}
                </Button>}
                {(onAgree && agreeText === undefined) &&
                    <Button className={'agree-button'} onClick={onAgree} color="primary" disabled={loader}>
                        {/* @ts-ignore */}
                        <Trans>
                            تایید
                        </Trans>
                    </Button>}
                {(onDisagree && disagreeText) &&
                    <Button className={'agree-button'} onClick={onDisagree} color="secondary" disabled={loader}>
                        {disagreeText}
                    </Button>}
                {(onDisagree && disagreeText === undefined) &&
                    <Button className={'agree-button'} onClick={onDisagree} color="secondary" disabled={loader}>
                        {/* @ts-ignore */}
                        <Trans>
                            انصراف
                        </Trans>
                    </Button>}
                {(onFile && disagreeText) &&
                    <Button className={'agree-button'} color="secondary" disabled={loader}>
                        <label htmlFor="ProPic">
                            <Typography>
                                انتخاب
                            </Typography>
                        </label>
                        <input type="file" id="ProPic" name="ProPic" onChange={onFile} hidden />
                    </Button>}
            </DialogActions>
        </Dialog>
    )
};

export default Modal